// extracted by mini-css-extract-plugin
module.exports = {"subLabel":"styles_subLabel__3Eu-I"};